// SEO / GEO 元信息与结构化数据管理器
// 负责在客户端统一写入 <title>、description、keywords、canonical、OG 标签，
// 并注入 / 清理当前页面的 JSON-LD 结构化数据（供搜索引擎富结果与生成式 AI 抓取）。

const META_NAME = 'name';
const META_PROPERTY = 'property';

function ensureMeta(attr, key) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
}

function setMetaValue(attr, key, content) {
  if (content == null || content === '') {
    const el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (el) el.remove();
    return;
  }
  const el = ensureMeta(attr, key);
  el.setAttribute('content', content);
}

// canonical 必须用 <link rel="canonical"> 而非 <meta>
function setCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (link) link.remove();
    return;
  }
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

/**
 * 写入页面级 meta 信息
 * @param {{title?:string, description?:string, keywords?:string, canonical?:string, og?:object}} meta
 */
export function setMeta(meta = {}) {
  if (meta.title) {
    document.title = meta.title;
    setMetaValue(META_PROPERTY, 'og:title', meta.title);
  }

  if (meta.description) {
    setMetaValue(META_NAME, 'description', meta.description);
    setMetaValue(META_PROPERTY, 'og:description', meta.description);
  }

  if (meta.keywords) {
    setMetaValue(META_NAME, 'keywords', meta.keywords);
  }

  if (meta.canonical) {
    setCanonical(meta.canonical);
  }

  setMetaValue(META_PROPERTY, 'og:type', (meta.og && meta.og.type) || 'website');
  setMetaValue(META_PROPERTY, 'og:url', (meta.og && meta.og.url) || meta.canonical);
}

/**
 * 注入当前页面的 JSON-LD 结构化数据（可传对象或对象数组）
 * 每次调用会先清理旧的 JSON-LD，避免多页共存导致数据冲突。
 * @param {object|object[]} schemas
 */
export function setJsonLd(schemas) {
  if (!schemas) {
    clearJsonLd();
    return;
  }
  const list = Array.isArray(schemas) ? schemas : [schemas];

  // 移除旧的 JSON-LD
  document.querySelectorAll('script[data-seo="jsonld"]').forEach((el) => el.remove());

  list.forEach((schema) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo', 'jsonld');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  });
}

export function clearJsonLd() {
  document.querySelectorAll('script[data-seo="jsonld"]').forEach((el) => el.remove());
}

export default { setMeta, setJsonLd, clearJsonLd };
